import React, { Fragment } from 'react';
import i18next from 'i18next';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import { connect } from 'react-redux';
import GameCard from './GameCard/GameCard';
import SApi from '../../api/slots';
import { setGames } from '../../actions/slotsActions';
import makeCancelable from '../../api/cancelable';
import Scrollbars from 'react-custom-scrollbars';
import Wallet from '../Wallet/Wallet';
import { isIOS } from '../../utils';

const LOAD_GAMES_INTERVAL = 10;

class SlotsGame extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      session: null,
      fullscreen: false,
    };

    this.requests = [];
    this.timer;

    this.gameRef = React.createRef();
  }

  componentDidMount() {
    const { balanceCash } = this.props;

    this.loadGames();
    window.addEventListener('message', this.processEvent, false);
  }

  componentWillUnmount() {
    document.querySelector('.app__game').classList.remove('app__game--slots');

    clearTimeout(this.timer);
    this.requests.forEach((cancel) => cancel());
    window.removeEventListener('message', this.processEvent);
  }

  showExchangeModal = () => {
    this.props.showModal(
      <Wallet
        activeForm="exchange"
        formProps={{ customTitle: i18next.t('slots.deposit') }}
      />,
      {
        position: 'top',
      }
    );
  };

  loadGames = () => {
    const { promise, cancel } = makeCancelable(SApi.loadGames());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.props.setGames(response.games || []);
      }

      this.timer = setTimeout(this.loadGames, LOAD_GAMES_INTERVAL * 1000);
    });
  };

  runGame = (name) => {
    this.setState({ session: null });

    const { promise, cancel } = makeCancelable(SApi.runGame(name));
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({ session: response.sesions });

        if (window.innerWidth < 600) {
          window.scroll(0, 80);
        }
      } else {
        if (response.data && response.data === 'CASH 0') {
          this.showExchangeModal();
        }
      }
    });
  };

  onClose = () => {
    document.querySelector('.app__game').classList.remove('app__game--slots');

    this.setState({ session: null });

    window.scroll(0, 0);

    const { promise, cancel } = makeCancelable(SApi.close());
    this.requests.push(cancel);

    promise.then((response) => {
      console.log(response);
    });
  };

  onSpinBegin = (balanceCash, bet) => {
    const { promise, cancel } = makeCancelable(
      SApi.spinBegin(balanceCash, bet)
    );
    this.requests.push(cancel);

    promise.then((response) => {
      console.log(response);
    });
  };

  onSpinFinish = (balanceCash, win) => {
    if (+balanceCash === 0) {
      this.showExchangeModal();
    }

    const { promise, cancel } = makeCancelable(
      SApi.spinFinish(balanceCash, win)
    );
    this.requests.push(cancel);

    promise.then((response) => {
      console.log(response);
    });
  };

  onChangeLines = (balanceCash) => {
    const { promise, cancel } = makeCancelable(SApi.changeLines(balanceCash));
    this.requests.push(cancel);

    promise.then((response) => {
      console.log(response);
    });
  };

  onChangeBet = (balanceCash) => {
    const { promise, cancel } = makeCancelable(SApi.changeBet(balanceCash));
    this.requests.push(cancel);

    promise.then((response) => {
      console.log(response);
    });
  };

  onFullscreenOn = () => {
    this.setState({ fullscreen: true });
  };

  onFullscreenOff = () => {
    this.setState({ fullscreen: false });
  };

  processEvent = (event) => {
    const { session } = this.state;

    if (session && event.origin.includes(session.server)) {
      console.log(event);
      const payload = JSON.parse(event.data);

      switch (payload.event) {
        case 'close': {
          this.onClose();
          break;
        }
        case 'spin-begin': {
          this.onSpinBegin(payload.credit, payload.bet);
          break;
        }
        case 'spin-finish': {
          this.onSpinFinish(payload.credit, payload.win);
          break;
        }
        case 'change-lines': {
          this.onChangeLines(payload.credit);
          break;
        }
        case 'change-bet': {
          this.onChangeBet(payload.credit);
          break;
        }
        case 'button': {
          if (isIOS()) {
            if (payload.name === 'fullscreen_on') {
              this.onFullscreenOn();
            }
            if (payload.name === 'fullscreen_off') {
              this.onFullscreenOff();
            }
          }
          break;
        }
      }
    }
  };

  renderGame() {
    const { session } = this.state;

    document.querySelector('.app__game').classList.add('app__game--slots');

    return (
      <div className="slots-game__frame" ref={this.gameRef}>
        <iframe allowFullScreen src={`${session.launch_url}&language=ru`} />
      </div>
    );
  }

  renderGrid() {
    const { session } = this.state;
    const { games } = this.props;

    return (
      <div className={cn('slots-game__grid', session && 'hidden')}>
        {games.map((game) => (
          <div className="slots-game__game" key={game.id_game}>
            <GameCard {...game} onClick={this.runGame} />
          </div>
        ))}
      </div>
    );
  }

  renderSlotsGame() {
    // const { signedIn, balanceCash } = this.props;
    const { session, fullscreen } = this.state;

    return (
      <div className={cn('slots-game', fullscreen && 'slots-game--fullscreen')}>
        {/* {signedIn && <StatusBar balance={balanceCash} />} */}

        <div className="slots-game__content">
          {!session && (
            <Fragment>
              {window.innerWidth > 960 ? (
                <Scrollbars
                  hideTracksWhenNotNeeded={true}
                  autoHeight={window.innerWidth <= 960}
                >
                  {this.renderGrid()}
                </Scrollbars>
              ) : (
                this.renderGrid()
              )}
            </Fragment>
          )}

          {session && this.renderGame()}
        </div>
      </div>
    );
  }

  render() {
    const { fullscreen } = this.state;

    if (!fullscreen) {
      return this.renderSlotsGame();
    } else {
      return ReactDOM.createPortal(this.renderSlotsGame(), document.body);
    }
  }
}

export default connect(
  (state) => {
    return {
      signedIn: !!state.user.profile,
      balanceCash: state.user.balanceCash,
      games: state.slots.games,
    };
  },
  {
    setGames,
  }
)(SlotsGame);



// WEBPACK FOOTER //
// ./app/components/SlotsGame/SlotsGame.jsx